import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByPublished'
})
export class OrderByPublishedPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
